import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Checkbox from 'Components/ComponentLibrary/Components/Uncategorized/Checkbox';
import PropTypes from 'prop-types';
import { FDAlert } from '@facet-wealth/design';

const useStyles = buildUseStyles('ActivateCell', ((theme) => ({
  root: {},
  check: {
    margin: theme.spacing(0),
  },
})));

const ActivateCell = ({ resource, onChange, readonly }) => {
  const classes = useStyles();
  const cantBeActivated = resource.attr('cannotBeActivatedDescription');

  function getCell() {
    if (cantBeActivated) {
      return (
        <FDAlert status={'warning'} title={resource.attr('cannotBeActivatedDescription')} />
      );
    }

    if (readonly) {
      return (
        <FDAlert status={'info'} title={'Account must be selected'} />
      );
    }

    return (
      <Checkbox
        className={classes.check}
        value={resource.isTruthy('createOnActivation')}
        onClick={() => {
          resource.attr('createOnActivation', (!resource.isTruthy('createOnActivation')).toString());
          onChange(resource);
        }}
      />
    );
  }

  return (
    <Box
      className={classes.root}
    >
      {getCell()}
    </Box>
  );
};

ActivateCell.defaultProps = {
  readonly: false,
};

ActivateCell.propTypes = {
  resource: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
};

export default ActivateCell;
